import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";
import Landing from "@/pages/Landing";
import UKLanding from "@/pages/UKLanding";
import USLanding from "@/pages/USLanding";
import StandardLanding from "@/pages/StandardLanding";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import Overview from "@/pages/dashboard/Overview";
import VenueInfo from "@/pages/dashboard/VenueInfo";
import EventsList from "@/pages/dashboard/EventsList";
import EventForm from "@/pages/dashboard/EventForm";
import OrdersList from "@/pages/dashboard/OrdersList";
import Settings from "@/pages/dashboard/Settings";
import Billing from "@/pages/dashboard/Billing";
import Dividends from "@/pages/dashboard/Dividends";
import Payouts from "@/pages/dashboard/Payouts";
import Members from "@/pages/dashboard/Members";
import Scanner from "@/pages/dashboard/Scanner";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminPress from "@/pages/admin/AdminPress";
import PublicVenue from "@/pages/PublicVenue";
import PublicMembership from "@/pages/PublicMembership";
import PublicEvent from "@/pages/PublicEvent";
import PublicPress from "@/pages/PublicPress";
import Press from "@/pages/Press";
import VenuePrivacy from "@/pages/VenuePrivacy";
import VenueTerms from "@/pages/VenueTerms";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<StandardLanding />} />
          <Route path="/uk" element={<UKLanding />} />
          <Route path="/us" element={<USLanding />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          {/* Hidden press page — reachable only by direct slug URL, no /press-releases index */}
          <Route path="/press-releases/:slug" element={<PublicPress />} />
          {/* Hidden press releases index — no link from any nav, robots-disallowed */}
          <Route path="/press" element={<Press />} />

          {/* Public buyer routes */}
          <Route path="/v/:slug" element={<PublicVenue />} />
          <Route path="/v/:slug/membership" element={<PublicMembership />} />
          <Route path="/v/:slug/membership/success" element={<PublicMembership />} />
          <Route path="/v/:slug/privacy" element={<VenuePrivacy />} />
          <Route path="/v/:slug/terms" element={<VenueTerms />} />
          <Route path="/v/:slug/e/:eventId" element={<PublicEvent />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />

          {/* Dashboard */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/press"
            element={
              <ProtectedRoute>
                <AdminPress />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Overview />} />
            <Route path="venue-info" element={<VenueInfo />} />
            <Route path="events" element={<EventsList />} />
            <Route path="events/new" element={<EventForm />} />
            <Route path="events/:id/edit" element={<EventForm />} />
            <Route path="orders" element={<OrdersList />} />
            <Route path="members" element={<Members />} />
            <Route path="payouts" element={<Payouts />} />
            <Route path="scanner" element={<Scanner />} />
            <Route path="settings" element={<Settings />} />
            <Route path="billing" element={<Billing />} />
            <Route path="dividends" element={<Dividends />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
